export default __webpack_public_path__ + "static/media/addStudent.c7f0ab80.ico";